import template from './registries.html';
import controller from './registries.controller';

let registriesComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default registriesComponent;
